import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const RockGardenIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Rock garden - dense field of large rocks */}
    <path d="M2 20h20" />
    <path d="M3 20l3-5 4 2 2-4 3 3 3-4 4 8" />
    <path d="M6 12l2-3 3 2" />
    <path d="M14 10l2-4 2 2" />
    <path d="M9 8l1-2" />
  </svg>
);
